import { HttpClient } from "@angular/common/http";
import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { InvoiceService } from "./../../../_services/invoice.service";
import { Config } from "src/app/_store/config";
import { ImpersonationService } from "src/app/_app-core/services/impersonation/impersonation.service";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";

@Component({
  selector: "app-invoice-submission",
  templateUrl: "./invoice-submission.component.html",
  styleUrls: ["./invoice-submission.component.scss"],
})
export class InvoiceSubmissionComponent implements OnInit {
  @ViewChild('sizeErrorModal') sizeErrorModal: TemplateRef<any>;
  Config = Config;
  invoiceTypes = [
    { label: "IRN e-invoice", type: "e-invoice" },
    { label: "Digitally Signed e-invoice", type: "ds-invoice" },
  ];
  supportingDocuments: any[] = [];
  loading = false;
  fileTypeError = false;
  fileSizeError = false;
  signatureError = false;
  qrCodeError = false;
  validateSignature = false;
  validateEinvoice = false;
  validateEinvoiceResubmit = false;
  responseData: any;
  displayName: any;
  message: any;
  poItems = [];
  fileName: string = "";
  poNo: any;
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  dsLoaderMsg = "";
  eLoaderMsg = "";
  eLoaderMsgResubmit = "";
  timeoutID;
  formSubmitted = false;
  previousUrl: any;
  totalSizeError;
  files: File[];

  invoiceData = new FormGroup({
    invoiceType: new FormControl(null, [Validators.required]),
    file: new FormControl(null),
    fileSource: new FormControl(null, [Validators.required]),
  });

  constructor(private router: Router, private route: ActivatedRoute, private http: HttpClient, private invoiceService: InvoiceService, private modalService: NgbModal, private imp: ImpersonationService, private authService: AuthService) {}

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  canDeactivate() {
    if (!this.formSubmitted) {
      this.loading = true;
      return false;
    } else {
      return true;
    }
  }

  exitForm() {
    this.loading = false;
    this.formSubmitted = true;
    this.previousUrl = this.route.snapshot.queryParams["returnUrl"] || "dashboard";
    //const returnUrl = this.route.snapshot.queryParamMap["returnUrl"];
    console.log(this.previousUrl);
    this.router.navigateByUrl(this.previousUrl);
  }

  cancelExit() {
    this.loading = false;
  }

  selectInvoice(event: any) {
    this.invoiceService.setFileElement(event[0]);

    if (event.length > 0) {
      const fileUploaded = event[0];
      if (fileUploaded.type !== "application/pdf") {
        this.fileTypeError = true;
      } else if (fileUploaded.size > Config.maxFileSize) {
        this.fileSizeError = true;
        this.modalService.open(this.sizeErrorModal, { centered: true, size: 'sm' });
      } else {
        this.invoiceData.patchValue({
          fileSource: fileUploaded,
        });
        this.fileTypeError = false;
        this.fileSizeError = false;
      }
    }

    this.fileName = event[0].name;
  }

  extrationMessages(msg, time) {
    this.timeoutID = setTimeout(() => {
      this.eLoaderMsg = msg;
    }, time);
  }

  extrationResubmitMessages(msg, time) {
    this.timeoutID = setTimeout(() => {
      this.eLoaderMsgResubmit = msg;
    }, time);
  }

  onInvoiceSubmit() {
    if (this.fileSizeError || this.fileTypeError) {
      return;
    }
    this.loading = true;
    this.formSubmitted = true;
    this.qrCodeError = false;
    this.signatureError = false;

    this.invoiceService.setDocuments(this.supportingDocuments);

    //console.log(convertPods);
    const pods: any = localStorage.getItem("pods");
    const convertPods = JSON.parse(pods);
    console.log(convertPods, "convertPods");

    // Create ledger array for each entry in convertPods
    const ledger: any[] = [];
    convertPods.forEach((pod: any) => {
      const ledgerEntry = {
        docType: "APINV",
        docDetail: {
          docFormat: "e-invoice",
          docCat: "po_based",
        },
        cmpCode: pod.cmpCode,
        purchaseOrg: pod.purchaseOrg,
        erpDocType: pod.erpDocType,
      };
      ledger.push(ledgerEntry);
    });

    console.log("Ledger array created:", ledger);

    const poItems: any = [];
    //console.log(convertPods);
    convertPods.forEach((p: any) => {
      if (p.docNo !== "" || typeof p.docNo !== "undefined") {
        poItems.push({
          poNo: p.poNo,
          itemNo: p.poLineNo,
          grn: p._id,
        });
      } else {
        poItems.push({
          poNo: p.poNo,
          itemNo: p.poLineNo,
          grn: "",
        });
      }
    });

    let companyCode = "";
    let purchaseOrg = "";
    let docType = "";
    if (convertPods[0].docNo !== "") {
      companyCode = convertPods[0].cmpCode;
      purchaseOrg = convertPods[0].purchaseOrg;
      docType = convertPods[0].erpDocType;
      //console.log("material");
    } else {
      companyCode = localStorage.getItem("servCompanyCode");
      purchaseOrg = localStorage.getItem("servPurchaseOrg");
      docType = localStorage.getItem("servDocType");
      //console.log("service");
    }

    const userData = {
      req: {
        companyCode: companyCode,
        purchaseOrg: purchaseOrg,
        docType: docType,
        items: poItems,
      },
    };

    if (this.invoiceData.value.invoiceType === "e-invoice") {
      this.validateEinvoice = true;
      this.invoiceService.setInvoiceType("po_based");
      this.invoiceService.setInvType("e-invoice");

      const formData: any = new FormData();
      formData.append("docNo", this.route.snapshot.params["poNo"]);
      formData.append("sellerCode", localStorage.getItem("sellerCode"));
      formData.append("supplierCode", localStorage.getItem("vendorCode"));
      formData.append("ledger", JSON.stringify(ledger));
      formData.append("invoiceFile", this.invoiceData.value.fileSource);
      formData.append("extractionVersion", "1");
      const impersonated = this.imp.canSubmitWhileImpersonated();
      if (impersonated) {
        formData.append("session", JSON.stringify(this.authService.getCurrentUser().eippSessionData.data.session));
      }

      this.eLoaderMsg = "Verifying QR Code";
      this.extrationMessages("Authenticating QR Code", 5000);
      this.extrationMessages("Extracting Data", 10000);
      this.extrationMessages("Validating Data", 15000);
      console.log(formData, "formData");

      this.invoiceService.extractInvoice(formData).subscribe(
        (res) => {
          this.loading = false;
          this.validateEinvoice = false;
          this.validateSignature = false;
          this.responseData = res;
          clearTimeout(this.timeoutID);
          //console.log(res);
          if (this.responseData && this.responseData.status === "error") {
            console.log("error");
            //console.log(this.responseData);

            //this.qrCodeError = true;

            //this.message = this.responseData.msg;

            if (impersonated) {
              this.qrCodeError = true;
              this.message = this.responseData.message || this.responseData.msg;
            } else if (this.responseData.msg.includes("unreadable")) {
              this.loading = true;
              this.validateEinvoiceResubmit = true;

              this.eLoaderMsgResubmit = "Sorry, QR code in your uploaded file is not legible. We will optimize your file now and retry.";

              formData.set("extractionVersion", "2");
              //this.eLoaderMsg = "Authenticating QR Code";

              this.extrationResubmitMessages("Verifying QR Code", 5000);
              this.extrationResubmitMessages("Authenticating QR Code", 10000);
              this.extrationResubmitMessages("Extracting Data", 15000);
              this.extrationResubmitMessages("Validating Data", 20000);

              setTimeout(() => {
                this.invoiceService.extractInvoice(formData).subscribe(
                  (res) => {
                    this.responseData = res;

                    if (this.responseData.length !== 0 && this.responseData.status === "error") {
                      this.validateEinvoiceResubmit = false;
                      this.qrCodeError = true;
                      this.message = this.responseData.msg;
                    } else {
                      this.qrCodeError = false;
                      this.poNo = this.route.snapshot.params["poNo"];
                      console.log("setProcessedInvoice");
                      console.log(this.responseData);

                      this.invoiceService.setProcessedInvoice(this.responseData);
                      this.router.navigate(["/invoice-preview", this.poNo]);
                    }
                  },
                  (error) => {}
                );
              }, 22000);
            }
          } else if (this.responseData && this.responseData.status === "success" && this.responseData.data) {
            // Map new response structure to expected fields
            const meta = this.responseData.data.meta || {};
            const rec = this.responseData.data.rec || {};
            const docDetail = rec.docDetail || {};
            const processedInvoice = {
              file_link: this.responseData.data.meta.src,
              supporting_docs: this.responseData.data.meta.supportingDocsSrc || [],
              invoice_number: this.responseData.data.rec.docId,
              invoice_date: this.responseData.data.meta.docDate,
              invoice_amount: this.responseData.data.rec.docDetail.docAmt,
              irn: this.responseData.data.rec.docDetail.docIrn,
              gstin: this.responseData.data.rec.docDetail.docGstin,
              cmpCode: convertPods[0].cmpCode,
              purchaseOrg: convertPods[0].purchaseOrg,
              erpDocType: convertPods[0].erpDocType,
              poNo: convertPods[0].poNo,
              username: this.invoiceService.getUsername(),
              user_id: this.invoiceService.getUserId(),
              barcodePrefix: this.responseData.data.rec.barcodePrefix,
              docFormat: "e-invoice",
            };
            this.qrCodeError = false;
            this.poNo = this.route.snapshot.params["poNo"];
            this.invoiceService.setProcessedInvoice(processedInvoice);
            console.log("processedInvoice all ok");
            console.log(processedInvoice);

            this.router.navigate(["/invoice-preview", this.poNo]);
          } else {
            // fallback for unexpected structure
            this.qrCodeError = false;
            this.poNo = this.route.snapshot.params["poNo"];
            this.invoiceService.setProcessedInvoice(this.responseData);
            console.log("processedInvoice error");
            console.log(this.responseData);

            this.router.navigate(["/invoice-preview", this.poNo]);
          }
        },
        (error) => {
          this.loading = false;
          this.validateEinvoice = false;
          this.validateSignature = false;
          this.qrCodeError = true;
          this.message = error;
          console.log(error);
        }
      );
    } else {
      this.validateSignature = true;
      this.invoiceService.setInvoiceType("po_based");
      this.invoiceService.setInvType("ds-invoice");
      const formData: any = new FormData();
      console.log(convertPods, "convertPods");

      console.log(convertPods[0].poNo, "convertPods[0].poNo");

      ledger.forEach((element) => {
        element.docDetail.docFormat = "ds-invoice";
      });
      formData.append("sellerCode", localStorage.getItem("sellerCode"));
      formData.append("ledger", JSON.stringify(ledger));
      formData.append("invoiceFile", this.invoiceData.value.fileSource);
      formData.append("supplierCode", localStorage.getItem("vendorCode"));
      formData.append("docNo", convertPods[0].poNo);

      this.dsLoaderMsg = "Verifying Signature";

      setTimeout(() => {
        this.dsLoaderMsg = "Authenticating Signature";
      }, 5000);
      setTimeout(() => {
        this.dsLoaderMsg = "Extracting Data";
      }, 10000);
      setTimeout(() => {
        this.dsLoaderMsg = "Validating Data";
      }, 15000);

      this.invoiceService.verifyDigitalSignature(formData).subscribe(
        (res) => {
          this.loading = false;
          this.validateEinvoice = false;
          this.validateSignature = false;
          this.responseData = res;
          console.log(res);
          if (this.responseData.length !== 0 && this.responseData.status === "error") {
            this.loading = true;
            this.signatureError = true;
            this.message = this.responseData.message || this.responseData.msg;
          } else {
            this.qrCodeError = false;
            this.poNo = this.route.snapshot.params["poNo"];
            // Map new response structure to expected fields
            const meta = this.responseData.data?.meta || {};
            const rec = this.responseData.data?.rec || {};
            const docDetail = rec.docDetail || {};
            this.invoiceService.setFileUrl(meta.src);
            const processedInvoice = {
              file_link: this.responseData.data.meta.src,
              supporting_docs: this.responseData.data.meta.supportingDocsSrc || [],
              invoice_number: this.responseData.data.rec.docId,
              invoice_date: this.responseData.data.meta.docDate,
              invoice_amount: this.responseData.data.rec.docDetail.docAmt,
              irn: this.responseData.data.rec.docDetail.docIrn,
              gstin: this.responseData.data.rec.docDetail.docGstin,
              cmpCode: convertPods[0].cmpCode,
              purchaseOrg: convertPods[0].purchaseOrg,
              erpDocType: convertPods[0].erpDocType,
              poNo: "",
              username: this.invoiceService.getUsername(),
              user_id: this.invoiceService.getUserId(),
              barcodePrefix: this.responseData.data.rec.barcodePrefix,
              docFormat: "ds-invoice",
            };
            this.invoiceService.setDataDigitalInvoice(processedInvoice);
            // docDate, dueDate = extarct-response: (docDate)
            // dueAmt, docAmt, docDetail.docAmt = extarct-response: (docAmt)
            // docType = "APINV" for invoice
            // docNo = extarct-response: (docId)
            // timestamp = generate at a that time (now)
            // currCode = docType.PO -> currCode
            // "status": "PENDING_SUBMISSION"
            // docDetail.docGstin = extarct-response: (docGstin)
            // docDetail.irn = extarct-response: (docIrn)
            // docRef.src = extarct-response: (meta.src)
            // lineItemDetail.poLineNo = docType.POD -> poLineNo
            // lineItemDetail.grn = docType.POD -> (_id or (docNofinYearitemNo~poLineNo))
            // lineItemDetail.grnNo = docType.POD -> docNo
            // cmpCode = docType.PO -> cmpCode
            // purchaseOrg = docType.PO -> purchaseOrg
            // erpDocType = docType.PO -> erpDocType

            //localStorage.setItem('invoice', JSON.stringify(this.responseData));
            this.router.navigate(["/invoice-preview-digital-invoice", this.poNo]);
          }
        },
        (error) => {
          console.log(error);
          this.loading = false;
          this.validateEinvoice = false;
          this.validateSignature = false;
          this.qrCodeError = true;
          this.message = error;
        }
      );
    }
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    this.formSubmitted = false;
  }

  closeFileErrorDialog() {
    this.loading = false;
    this.fileTypeError = false;
    this.qrCodeError = false;
  }

  closeSignatureErrorDialog() {
    this.loading = false;
    this.signatureError = false;
  }
}
